<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BcJbFE/tc-custom/9781459293014.jpg?1705003723443" alt="This image is the cover for the book Drakon Baby Bargain, The Drakon Royals"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Drakon Baby Bargain, The Drakon Royals
      </h1>
      <p class="bookDescription body article font2">
        <i><b>A deal sealed with passion!</b></i><i><b> </b></i><br/><br/>Illegitimate and overlooked, Eleni, Princess of Drakon, yearns for a family. At a masquerade ball, one stolen kiss with a stranger sparks an opportunity! Gabriel Marquez wants her to care for his childcould this be Eleni's chance to strike a deal of her own? <br/><br/>Gabriel, Drakon's biggest investor, is shocked by Eleni's bold bargainingbut a convenient marriage would be advantageous to them both! He'll gain a stand-in mother for his daughter, and Eleni the baby she longs for. Except Gabriel hasn't predicted the fire raging between themone which will bind them together forever!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tara Pammi
      </h2>
      
      <p class="authorDescription body article">Tara Pammi can't remember a moment when she wasn't lost in a book, especially a romance which, as a teenager, was much more exciting than mathematics textbook. Years later Tara&rsquo;s wild imagination and love for the written word revealed what she really wanted to do: write! She lives in Colorado with the most co-operative man on the planet and two daughters. Tara loves to hear from readers and can be reached at tara.pammi@gmail.com or her website www.tarapammi.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e0c48436